<template>
  <div>
    <v-toolbar flat color="white">
      <h3 class="title">Cancellations <span class="grey--text" v-if="!loading">({{cancellations.length}} total)</span></h3>
      <v-spacer></v-spacer>
      <v-menu
        ref="monthMenu"
        v-model="monthMenuOpen"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="selectedMonthLabel"
            label="Month"
            prepend-icon="event"
            readonly
            v-on="on"
            style="max-width: 220px"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="selectedMonth"
          type="month"
          no-title
          @input="onMonthChange"
        ></v-date-picker>
      </v-menu>
    </v-toolbar>
    <v-data-table
      :loading="loading"
      :items="cancellations"
      :headers="headers"
      :rows-per-page-items="[15, 25, 50, 100]"
    >
      <template v-slot:items="props">
        <td class="text-xs-center">{{ props.item.circuitNumber }}</td>
        <td class="text-xs-center">
          <span v-if="props.item.packagesIsp && props.item.packagesIsp.customerOrganisation">{{ props.item.packagesIsp.customerOrganisation.name }}</span>
        </td>
        <td class="text-xs-center">
          <span v-if="props.item.location">{{ props.item.location.locationDescription }}</span>
        </td>
        <td class="text-xs-center">
          <span v-if="props.item.packagesIsp && props.item.packagesIsp.packagesFno">{{ props.item.packagesIsp.packagesFno.packageCode }}</span>
        </td>
        <td class="text-xs-center">{{ formatDate(props.item.fnoDeactivationDate) }}</td>
      </template>
      <template v-slot:no-data>
        <v-alert :value="true" color="info" icon="info" outline>
          No cancellations for {{ selectedMonthLabel }}.
        </v-alert>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import Api from "@/services/Api";
export default {
  data() {
    let now = new Date()
    let ym = now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0')
    return {
      loading: false,
      cancellations: [],
      selectedMonth: ym,
      monthMenuOpen: false,
      headers: [
        { text: 'Circuit Number', value: 'circuitNumber', align: 'center', sortable: false },
        { text: 'ISP Name', value: 'ispName', align: 'center', sortable: false },
        { text: 'Address', value: 'address', align: 'center', sortable: false },
        { text: 'FNO Package Code', value: 'packageCode', align: 'center', sortable: false },
        { text: 'FNO Deactivation Date', value: 'fnoDeactivationDate', align: 'center', sortable: false }
      ]
    }
  },
  computed: {
    selectedMonthLabel() {
      if (!this.selectedMonth) return ''
      let parts = this.selectedMonth.split('-')
      let d = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, 1)
      return d.toLocaleString('default', { month: 'long', year: 'numeric' })
    }
  },
  created() {
    this.fetchCancellations()
  },
  methods: {
    onMonthChange() {
      this.monthMenuOpen = false
      this.fetchCancellations()
    },
    formatDate(date) {
      if (!date) return ''
      return new Date(date).toLocaleDateString()
    },
    async fetchCancellations() {
      this.loading = true
      let parts = this.selectedMonth.split('-')
      let year = parts[0]
      let month = parts[1]
      await Api()
        .get("/serviceAccounts/cancellations/month", { params: { year: year, month: month } })
        .then(response => {
          this.cancellations = response.data;
        });
      this.loading = false
    }
  }
}
</script>
